<template>
  <div>
    <el-form :form="filterForm" inline label-suffix="：">
      <el-form-item label="供应商">
        <el-input
          v-model.trim="filterForm.keyword"
          placeholder="请输入供应商名称"
          clearable
        />
      </el-form-item>
      <el-form-item label="所属行业">
        <el-select v-model="filterForm.industry" clearable>
          <el-option label="全部" value="" />
          <el-option
            v-for="item in companyIndustryDict.array"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="地区">
        <base-area-select :address.sync="address" address-range="city" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSearch">搜索</el-button>
        <el-button @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>
    <jczh-table-content
      ref="table"
      :data="platformSupplierTableData"
      :option="platformSupplierTableOption"
      pagination
      :page.sync="page"
      :limit.sync="size"
      :total="total"
      selection
      table-id="companyId"
      :selected="selected"
      :selectable="selectable"
      @selection-change="handleSelectChange"
      @select="handleSelect"
      @select-all="handleSelectAll"
    />
  </div>
</template>

<script>
import BaseAreaSelect from '@/components/common/BaseAreaSelect'
import { companyIndustryDict } from '@/dictionary/company'
import { listFilterMixin } from 'jczh-ui'
import { searchSupplierListApi } from '@/api/company'
import { mapState } from 'vuex'

export default {
  name: 'PlatformSupplierFilterTable',

  components: {
    BaseAreaSelect
  },

  mixins: [listFilterMixin],

  props: {
    selected: {
      type: Array,
      default: () => []
    },

    disabledArray: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      companyIndustryDict,
      filterForm: {
        keyword: '',
        industry: '',
        region: '',
        province: '',
        city: ''
      },
      platformSupplierTableData: [],
      platformSupplierTableOption: [
        {
          label: '供应商名称',
          prop: 'companyName',
          minWidth: 140
        },
        {
          label: '联系人',
          prop: 'contactName'
        },
        {
          label: '联系电话',
          prop: 'contactTel'
        },
        {
          label: '所属行业',
          prop: 'industry',
          filter: value => companyIndustryDict.translate(value).label || '-'
        },
        {
          label: '地区',
          prop: 'region,province',
          filter: value => {
            if (value.region === '中国') {
              return `${value.province} - ${value.city}`
            } else {
              return value.region || '-'
            }
          },
          minWidth: 120
        }
      ],
      total: 0
    }
  },

  computed: {
    ...mapState('company', ['companyId']),

    address: {
      get() {
        return {
          country: this.filterForm.region,
          province: this.filterForm.province,
          city: this.filterForm.city,
          foreign:
            this.filterForm.region !== '中国' ? this.filterForm.region : ''
        }
      },
      set(value) {
        const { country, province, city, foreign } = value
        this.filterForm.region = country
        this.filterForm.province = province
        this.filterForm.city = city
        if (foreign) {
          this.filterForm.region = foreign
        }
      }
    },

    selectable() {
      return row => {
        return (
          Number(row.companyId) !== this.companyId &&
          this.disabledArray.every(item => item.companyId !== row.companyId)
        )
      }
    }
  },

  created() {
    this.getList()
  },

  methods: {
    async getList() {
      this.epitaxy()
      const params = Object.assign(
        {},
        {
          page: this.page,
          size: this.size
        },
        this.filterForm
      )
      try {
        const { data } = await searchSupplierListApi(params)
        this.platformSupplierTableData = data?.records || []
        this.total = data?.total || 0
      } catch (e) {
        this.$message.error(e.message)
      }
    },

    handleSelect(selection, row) {
      this.$emit('select', selection, row)
    },

    handleSelectChange(selection) {
      const temp = this.selected.filter(s => {
        return (
          this.platformSupplierTableData.findIndex(
            v => v.companyId === s.companyId
          ) < 0
        )
      })
      const tempSelection = [...selection]
      temp.forEach(t => {
        if (selection.findIndex(s => s.companyId === t.companyId) < 0) {
          tempSelection.push(t)
        }
      })

      this.$emit('selectionChange', tempSelection)
    },

    clearSelection() {
      this.$refs.table.clearSelection()
    },

    handleSelectAll(selection) {
      this.$emit('selectAll', selection, this.platformSupplierTableData)
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-table {
  .el-table__fixed {
    height: 100% !important;
  }
}
</style>
